import { useEffect, useState } from "react";
import { Track } from "@/lib/track/track";
import { useStudio } from "@/contexts/studio-context";

export function useTrackList() {
  const { studio } = useStudio();
  const trackManager = studio?.getTrackManager();
  const [tracks, setTracks] = useState<Track[]>([]);

  useEffect(() => {
    if (!trackManager) return;

    // Mise à jour initiale
    setTracks(trackManager.getTracks());

    // Écoute des changements
    const unsubscribe = trackManager.onChange(() => {
      setTracks(trackManager.getTracks());
    });

    return unsubscribe;
  }, [trackManager]);

  return tracks;
}
